export default function getContentfulLocale(locale?: string, market?: string) {
  if (locale == 'en' && (market == 'australia' || market == 'au')) {
    return 'en-AU';
  }
  
  if (locale == 'en' && (market == 'uk' || market == 'gb')) {
    return 'en-GB';
  }

  if (locale == 'en' && (market == 'emea' || market == 'eu')) {
    return 'en-EU';
  }

  if (locale == 'en' || !locale) {
    return 'en-US';
  }

  return locale;
}